'use strict';
'use es6';

// Factory for the .required version of the propType function.
// See https://www.ian-thomas.net/custom-proptype-validation-with-react/

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createChainablePropType;
function createChainablePropType(validate, propTypeName) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  function checkType(isRequired, props, propName, componentName) {
    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required prop `' + propName + '` was not specified in `' + componentName + '`.');
      }
      return null;
    }

    for (var _len = arguments.length, rest = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentName].concat(rest));
  }

  var introspectionObj = {
    args: args,
    type: propTypeName
  };

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.__INTROSPECTION__ = introspectionObj;
  chainedCheckType.isRequired = checkType.bind(null, true);
  chainedCheckType.isRequired.__INTROSPECTION__ = _extends({}, introspectionObj, {
    isRequired: true
  });

  return chainedCheckType;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/propTypes/createChainablePropType.js
// module id = 46
// module chunks = 3 4 5